import { currencyFormat, getTotalPriceWithDiscount } from "../utils/price";
import { ProFormCheckbox, ProDescriptions } from "@ant-design/pro-components";

const PriceInfo = ({ selectedProducts, discount, increasePrice, clientType }) => {
  const totalPriceWithDiscount = getTotalPriceWithDiscount(
    selectedProducts,
    increasePrice,
    discount
  );

  const isVatClient = clientType === "ENTITY";
  const totalWithVat = isVatClient ? Math.round(totalPriceWithDiscount * 1.16) : 0;
  const vatAmount = isVatClient ? Math.round(totalWithVat - totalPriceWithDiscount) : 0;

  return (
    <div
      style={{
        maxWidth: 650,
        marginTop: 30,
      }}
    >
      <ProDescriptions column={1}>
        <ProDescriptions.Item label="Общая сумма">
          <b>
            {currencyFormat(totalPriceWithDiscount)}&nbsp;(тенге)
          </b>
        </ProDescriptions.Item>

        {isVatClient && (
          <ProDescriptions.Item label="Общая сумма с НДС">
            <b>
              {currencyFormat(totalWithVat)}&nbsp;(тенге) с НДС (16% — {currencyFormat(vatAmount)} тенге)
            </b>
          </ProDescriptions.Item>
        )}

        <ProDescriptions.Item>
          <ProFormCheckbox
            style={{
              margin: 0,
            }}
            name="hasSignature"
          >
            Документы с печатью
          </ProFormCheckbox>
        </ProDescriptions.Item>
      </ProDescriptions>
    </div>
  );
};

export default PriceInfo;
